export default {"src":"/_next/static/media/render.d6bb9ecf.svg","height":840,"width":1524,"blurWidth":0,"blurHeight":0};